/**************************************************
 * Nombre:       Detalle_Producto_Match
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import '@splidejs/react-splide/css';
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {TituloTexto} from "./SubComponentes/TituloTexto";
import Tarjeta_Look from "../../Tarjetas/Tarjeta_Look";
import {useEffect, useRef, useState} from "react";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";

const Detalle_Producto_Match = ({producto, setArrProductos}) => {
    const {sCell} = useResponsive()
    const [looks, setLooks] = useState([])
    const refe = useRef()


    useEffect(() => {

        if (producto && producto.id) {
            setLooks([])
            let w = [where('estado', '==', 'Publicado'), where('productos', 'array-contains', producto.id)]
            obtenerColWheres({col: 'looks', wheres: w}).then((dox) => {
                if (dox.res) {
                    setLooks(dox.data)
                }
            })
        }


    }, [producto])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 0 : 6}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <TituloTexto texto={'#AMEVILOOK'} titulo={'COMPRA EL LOOK'} dir={'center'}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'center', mt: 8}}>
                    {sCell ?

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Splide
                                ref={refe}
                                aria-label="My Favorite Images" style={{width: '100%'}}
                                options={{
                                    autoplay: false,
                                    speed: 1000,
                                    rewind: true,
                                    perPage: 1,
                                    arrows: false,
                                    pagination: true,
                                    width: '100%',
                                    drag: 'false',
                                    interval: 1000,
                                    noDrag: true,
                                    type: 'loop',
                                    gap: 10,
                                    padding: 30,
                                }}
                            >

                                {looks.map((item, index) => (
                                    <SplideSlide>

                                        <Tarjeta_Look item={item}/>
                                    </SplideSlide>
                                ))}


                            </Splide>
                        </Grid>
                        :

                        looks.map((item, index) => (
                            <Grid container size={{xs: 12, sm: 6, md: 4}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Look item={item}/>
                            </Grid>
                        ))


                    }
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Producto_Match
